module.exports = __webpack_public_path__ + "img/pay.ca87cdb7.jpg";